// =============================================================================
// Enums (as const objects for erasableSyntaxOnly compatibility)
// =============================================================================

export const DocumentStatus = {
  Uploaded: 'Uploaded',
  Processing: 'Processing',
  Ready: 'Ready',
  Failed: 'Failed',
} as const;
export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

export const DocumentType = {
  Pdf: 'Pdf',
  Docx: 'Docx',
  Doc: 'Doc',
  Rtf: 'Rtf',
} as const;
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const ImportSource = {
  Upload: 'Upload',
  BulkUpload: 'BulkUpload',
  GoogleDrive: 'GoogleDrive',
  OneDrive: 'OneDrive',
} as const;
export type ImportSource = (typeof ImportSource)[keyof typeof ImportSource];

export const ImportJobStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Completed: 'Completed',
  PartiallyFailed: 'PartiallyFailed',
  Failed: 'Failed',
} as const;
export type ImportJobStatus = (typeof ImportJobStatus)[keyof typeof ImportJobStatus];

export const AuditAction = {
  DocumentUploaded: 'DocumentUploaded',
  DocumentViewed: 'DocumentViewed',
  DocumentDownloaded: 'DocumentDownloaded',
  DocumentDeleted: 'DocumentDeleted',
  SearchPerformed: 'SearchPerformed',
  TenantCreated: 'TenantCreated',
  TenantUpdated: 'TenantUpdated',
  UserInvited: 'UserInvited',
  ImportStarted: 'ImportStarted',
} as const;
export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const MetadataApprovalStatus = {
  None: 'None',
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;
export type MetadataApprovalStatus = (typeof MetadataApprovalStatus)[keyof typeof MetadataApprovalStatus];

export const SprawaPortalStatus = {
  Nowa: 'Nowa',
  WToku: 'WToku',
  Zakonczona: 'Zakonczona',
  Zawieszona: 'Zawieszona',
  Archiwalna: 'Archiwalna',
} as const;
export type SprawaPortalStatus = (typeof SprawaPortalStatus)[keyof typeof SprawaPortalStatus];

export const PosiedzenieType = {
  Rozprawa: 'Rozprawa',
  PosiedzenieNiejawne: 'PosiedzenieNiejawne',
  PosiedzenieJawne: 'PosiedzenieJawne',
  Inne: 'Inne',
} as const;
export type PosiedzenieType = (typeof PosiedzenieType)[keyof typeof PosiedzenieType];

export const CourtType = {
  SadNajwyzszy: 'SadNajwyzszy',
  NaczelnySadAdministracyjny: 'NaczelnySadAdministracyjny',
  WojewodzkiSadAdministracyjny: 'WojewodzkiSadAdministracyjny',
  Apelacyjny: 'Apelacyjny',
  Okregowy: 'Okregowy',
  Rejonowy: 'Rejonowy',
  WojskowyOkregowy: 'WojskowyOkregowy',
  WojskowyGarnizonowy: 'WojskowyGarnizonowy',
  TrybunalKonstytucyjny: 'TrybunalKonstytucyjny',
  TrybunalStanu: 'TrybunalStanu',
} as const;
export type CourtType = (typeof CourtType)[keyof typeof CourtType];

// Party roles are free-form strings from the portal (e.g. "Powód", "Pozwany",
// "wnioskodawczyni", "uczestnik", etc.)
export type PartyRole = string;
